import { LabelGenerator } from '../../types';

export const isAutomaticTaxHandling: LabelGenerator = (product) => {
  const {
    deposit_taking_bank: {
      branch_country: {
        domestic_taxation_applicable: domesticTaxationApplicable,
        source_tax_applicable: sourceTaxApplicable,
        source_tax_type: sourceTaxType,
      },
    },
  } = product;
  if (domesticTaxationApplicable) {
    return 'AutomaticTaxHandling';
  }
  return (
    sourceTaxApplicable === true &&
    domesticTaxationApplicable === false &&
    sourceTaxType === 'DOMESTIC' &&
    'AutomaticTaxHandling'
  );
};
